import React, {ReactElement, useCallback, useMemo} from 'react';
import {useDispatch} from 'react-redux';

import {QuestionIcon} from '../../../resources/Icons';
import {Actions} from '../gameSlice';
import {useCurrentQuestionComputed, useGameStatus} from '../hooks';
import {GamePhase} from '../types';
import Dropdown from './buttons/Dropdown';
import HelpExpert from './HelpExpert';
import HelpFindOut from './HelpFindOut';
import HelpNeighbour from './HelpNeighbour';

const HelpMenu = (): ReactElement | null => {
  const dispatch = useDispatch();
  const gameStatus = useGameStatus();
  const question = useCurrentQuestionComputed();

  const expertAdvicePurchased = useMemo(
    () => !!question && gameStatus.expertAdvices.includes(question.id),
    [gameStatus.expertAdvices, question]
  );

  const purchaseExpertAdvice = useCallback(() => {
    if (!question) return false;
    if (expertAdvicePurchased) return true;
    try {
      dispatch(Actions.buyExpertAdvice(question));
      return true;
    } catch (err) {
      alert(err);
    }
    return false;
  }, [dispatch, expertAdvicePurchased, question]);

  if (gameStatus.phase !== GamePhase.questions) return null;

  if (!question || !question.help) return null;
  const {text, links, neighbour, expert} = question.help;

  if (!neighbour && !expert && !text && !links?.length) return null;

  return (
    <Dropdown
      id="helpMeDecide"
      key={question.id}
      className="mobile:!rounded-2xl !rounded-full"
      buttonIcon={<QuestionIcon className="w-14 h-14" />}
      buttonLine1="Help me"
      buttonLine2="decide"
    >
      {neighbour && <HelpNeighbour text={neighbour.text} />}
      {expert && (
        <HelpExpert
          text={expert.text}
          cost={expert.cost}
          canPay={true}
          purchased={expertAdvicePurchased}
          onPayClick={purchaseExpertAdvice}
        />
      )}
      {(!!text || links?.length) && <HelpFindOut text={text} links={links} />}
    </Dropdown>
  );
};

export default HelpMenu;
